import { Settings } from "../../../Settings";
import ValueCalculator from "../../../util/ValueCalculator";
import SkillNodePurchaseListener from "../SkillNodePurchaseListener";
import NumberValueSkillNode from "./NumberValueSkillNode";

export default class CoolDownSkillNode extends NumberValueSkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     * @param {number} valuePerSkillLevel
     * @param {NumberValue} numberValue
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue) {
        super(id, 'Cool Down - ' + Settings.skill.common.coolDownSecondsPerUpgrade + ' sec', 
            null, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue);
    }

    /**
     * @override
     * @returns {string}
     */
    getDescription() {
        return ValueCalculator.getSkillCoolDownSeconds(this.numberValue) + ' seconds';
    }

}